import React, { Component, Suspense, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as router from "react-router-dom";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { logOut } from "../../containers/LoginContainer/actions";
import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from "@coreui/react";
import { unreadnotifications } from "../../containers/NotificationContainer/action";

// sidebar nav config
// import navigation from "../../_nav";
//import navigation2 from "../../_nav2";
import { filterNavItems } from "../../_nav";
// routes config
import routes from "../../routes";
import { pusher } from "../../service/pusher";

import LoadAction from "../TripDesignContainer/action";
import { fetchLoaddata } from "../LoadBoardContainer/action";
import { fetchTripEvents } from "../TripEventsContainer/action";
import { fetchinboxrequest } from "../PartnerRequestContainer/action";
import SubscriptionAction from "../MySubscriptionContainer/action";
import ExpenseAction from "../ExpenseContainer/action";
import fetchTripPlanByIdAction from "../TripDesignCrudContainer/action";
const DefaultAside = React.lazy(() => import("./DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));

function DefaultLayout(props) {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     plannedList: this.props,
  //   };
  // }
  // state = {
  //   navItems: { items: [] },
  // };
  useEffect(() => {
    let userDetails = JSON.parse(localStorage.getItem("user"));
    pusherfunction(userDetails);
    return () => (userDetails ? pusher.unsubscribe(userDetails.id) : "");
  }, [props.plannedList, props.tripplantab, props.unreadnotificationcount]);
  // useEffect(() => {
  //   console.log("=========");
  // }, [props.plannedList, props.tripplantab, props.unreadnotificationcount]);
  const loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  const signOut = (e) => {
    let userDetails = JSON.parse(localStorage.getItem("user"));
    pusher.unsubscribe(userDetails.id);
    e.preventDefault();
    props.logOutAction();
    props.history.push("/login");
  };

  // componentDidMount = () => {
  //   console.log("======ttttttt========", this.state);
  //   let userDetails = JSON.parse(localStorage.getItem("user"));
  //   const props = this.state;
  //   // this.pusherfunction(userDetails, props);
  //   if (userDetails) {
  //     const pusherchannel = pusher.subscribe(userDetails && userDetails.id);
  //     console.log("======tttttttpusher========", this.state);
  //     pusherchannel.bind("newLoad", function (data) {
  //       console.log("newLoad event");
  //       console.log(data);
  //       props.location.state === undefined &&
  //         props.tripplantab === "created" &&
  //         props.fetchLoadData({ page: 1 });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });

  //     pusherchannel.bind("shipperCancelled", function (data) {
  //       console.log("load cancel event");
  //       console.log(data);
  //       props.tripplantab === "created" && props.fetchLoadData({ page: 1 });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });

  //     pusherchannel.bind("loadActive", function (data) {
  //       console.log("loadActive event");
  //       console.log(data);
  //       props.getLoadData({ page: 1, status: "ontrip,planned" });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });

  //     pusherchannel.bind("loadOntrip", function (data) {
  //       console.log("loadOntrip event");
  //       console.log(data);
  //       props.getLoadData({ page: 1, status: "ontrip,planned" });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });

  //     pusherchannel.bind("tripStatusChange", function (data) {
  //       console.log("tripStatusChange event");
  //       console.log(data);
  //       props.fetchTripEvents({ page: 1 });
  //       if (
  //         this.props.plannedList.length > 0 &&
  //         this.props.plannedList[0].id === data.loadId
  //       ) {
  //         props.fetchTripPlanByIdAction(data.loadId);
  //       }
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });

  //     pusherchannel.bind("driverTripAccepted", function (data) {
  //       console.log("driverTripAccepted event");
  //       console.log(data);
  //       props.fetchTripEvents({ page: 1 });
  //       if (
  //         this.state.plannedList.length > 0 &&
  //         this.state.plannedList[0].id === data.loadId
  //       ) {
  //         props.fetchTripPlanByIdAction(data.loadId);
  //       }
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("tripPlanOntrip", function (data) {
  //       console.log("tripPlanOntrip event");
  //       console.log(data);
  //       props.fetchTripEvents({ page: 1 });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("tripPlanCompleted", function (data) {
  //       console.log("tripPlanCompleted event");
  //       console.log(data);
  //       props.fetchTripEvents({ page: 1 });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("newPatnrRqst", function (data) {
  //       console.log("newPatnrRqst event");
  //       console.log(data);
  //       props.fetchinboxrequest({ page: 1 });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("expenseCreated", function (data) {
  //       console.log("expenseCreated event");
  //       console.log(data);
  //       props.fetchexpense({ page: 1 });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("subscription", function (data) {
  //       console.log("subscription event");
  //       console.log(data);
  //       props.fetchmyplans({ page: 1 });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("newBidRecieved", function (data) {
  //       console.log("newBidRecieved event");
  //       console.log(data);
  //       props.getLoadData({ page: 1, status: "created" });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("bidAccepted", function (data) {
  //       console.log("bidAccepted event");
  //       console.log(data);
  //       props.getLoadData({ page: 1, status: "pending,bid" });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("bidCancel", function (data) {
  //       console.log("bidCancel event");
  //       console.log(data);
  //       props.getLoadData({ page: 1, status: "cancelled,rejected" });
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //     pusherchannel.bind("driverCancelTrip", function (data) {
  //       console.log("driverCancelTrip event");
  //       console.log(data);
  //       console.log("=======this.props.plannedList=====", props, this.state);
  //       if (
  //         this.state &&
  //         this.state.plannedList.length > 0 &&
  //         this.state.plannedList[0].id === data.loadId
  //       ) {
  //         props.fetchTripPlanByIdAction(data.loadId);
  //       }
  //       props.unreadnotifications({ fromPusher: true, data: data });
  //     });
  //   }
  // };

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   console.log("========nextProps=======", nextProps);
  //   let userDetails = JSON.parse(localStorage.getItem("user"));
  //   if (nextProps.plannedList !== this.state.plannedList) {
  //     this.setState({ plannedList: nextProps.plannedList });
  //   }
  //   // this.pusherfunction(userDetails, nextProps);
  // }

  const pusherfunction = (userDetails) => {
    if (userDetails) {
      const pusherchannel = pusher.subscribe(userDetails && userDetails.id);
      console.log("======tttttttpusher========");
      pusherchannel.bind("newLoad", function (data) {
        console.log("newLoad event");
        console.log(data);
        props.location.state === undefined &&
          props.tripplantab === "created" &&
          props.fetchLoadData({ page: 1 });
        props.unreadnotifications({ fromPusher: true, data: data });
      });

      pusherchannel.bind("shipperCancelled", function (data) {
        console.log("load cancel event");
        console.log(data);
        props.tripplantab === "created" && props.fetchLoadData({ page: 1 });
        props.unreadnotifications({ fromPusher: true, data: data });
      });

      pusherchannel.bind("loadActive", function (data) {
        console.log("loadActive event");
        console.log(data);
        props.getLoadData({ page: 1, status: "ontrip,planned" });
        props.unreadnotifications({ fromPusher: true, data: data });
      });

      pusherchannel.bind("loadOntrip", function (data) {
        console.log("loadOntrip event");
        console.log(data);
        props.getLoadData({ page: 1, status: "ontrip,planned" });
        props.unreadnotifications({ fromPusher: true, data: data });
      });

      pusherchannel.bind("tripStatusChange", function (data) {
        console.log("tripStatusChange event");
        console.log(data);
        props.fetchTripEvents({ page: 1 });
        if (
          props.plannedList.length > 0 &&
          props.plannedList[0].id === data.loadId
        ) {
          props.fetchTripPlanByIdAction(data.loadId);
        }
        props.unreadnotifications({ fromPusher: true, data: data });
      });

      pusherchannel.bind("driverTripAccepted", function (data) {
        console.log("driverTripAccepted event");
        console.log(data);
        props.fetchTripEvents({ page: 1 });
        if (
          props.plannedList.length > 0 &&
          props.plannedList[0].id === data.loadId
        ) {
          props.fetchTripPlanByIdAction(data.loadId);
        }
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("tripPlanOntrip", function (data) {
        console.log("tripPlanOntrip event");
        console.log(data);
        props.fetchTripEvents({ page: 1 });
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("tripPlanCompleted", function (data) {
        console.log("tripPlanCompleted event");
        console.log(data);
        props.fetchTripEvents({ page: 1 });
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("newPatnrRqst", function (data) {
        console.log("newPatnrRqst event");
        console.log(data);
        props.fetchinboxrequest({ page: 1 });
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("expenseCreated", function (data) {
        console.log("expenseCreated event");
        console.log(data);
        props.fetchexpense({ page: 1 });
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("subscription", function (data) {
        console.log("subscription event");
        console.log(data);
        props.fetchmyplans({ page: 1 });
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("newBidRecieved", function (data) {
        console.log("newBidRecieved event");
        console.log(data);
        props.getLoadData({ page: 1, status: "created" });
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("bidAccepted", function (data) {
        console.log("bidAccepted event");
        console.log(data);
        props.getLoadData({ page: 1, status: "pending,bid" });
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("bidCancel", function (data) {
        console.log("bidCancel event");
        console.log(data);
        props.getLoadData({ page: 1, status: "cancelled,rejected" });
        props.unreadnotifications({ fromPusher: true, data: data });
      });
      pusherchannel.bind("driverCancelTrip", function (data) {
        console.log("driverCancelTrip event");
        console.log(data);
        console.log("=======this.props.plannedList=====", props);
        if (
          props &&
          props.plannedList.length > 0 &&
          props.plannedList[0].id === data.loadId
        ) {
          props.fetchTripPlanByIdAction(data.loadId);
        }
        props.unreadnotifications({ fromPusher: true, data: data });
      });
    }
  };

  // componentWillUnmount() {
  //   let userDetails = JSON.parse(localStorage.getItem("user"));
  //   if (userDetails) {
  //     pusher.unsubscribe(userDetails.id);
  //   }
  // }

  // render() {
  let navItems = filterNavItems() || {};
  //   const user = localStorage.getItem("UserRole");

  return (
    <div className="app">
      <AppHeader fixed>
        <Suspense fallback={loading()}>
          <DefaultHeader
            onLogout={(e) => signOut(e)}
            unreadnotifications={props.unreadnotifications}
            unreadnotificationcount={props.unreadnotificationcount}
          />
        </Suspense>
      </AppHeader>
      <div className="app-body">
        <AppSidebar fixed display="lg">
          <AppSidebarHeader />
          <AppSidebarForm />
          <Suspense>
            <AppSidebarNav
              //navConfig={user === "licensee" ? navigation2 : navigation}//if there is user login called Licensee, we need another nav
              // navConfig={navigation}
              navConfig={navItems}
              {...props}
              router={router}
            />
          </Suspense>
          <AppSidebarFooter />
          <AppSidebarMinimizer />
        </AppSidebar>
        <main className="main">
          <AppBreadcrumb appRoutes={routes} router={router} />
          <Container fluid>
            <Suspense fallback={loading()}>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={(props) =>
                        localStorage.getItem("token") !== null ? (
                          <route.component {...props} />
                        ) : (
                          <Redirect from="/" to="/login" />
                        )
                      }
                    />
                  ) : null;
                })}

                <Redirect from="/" to="/dashboard" />
              </Switch>
            </Suspense>
          </Container>
        </main>
        <AppAside fixed>
          <Suspense fallback={loading()}>
            <DefaultAside />
          </Suspense>
        </AppAside>
      </div>
      <AppFooter>
        <Suspense fallback={loading()}>
          <DefaultFooter />
        </Suspense>
      </AppFooter>
    </div>
  );
  // }
}

function bindAction(dispatch) {
  return {
    logOutAction: () => {
      dispatch(logOut());
    },
    unreadnotifications: (params) => {
      dispatch(unreadnotifications(params));
    },
    fetchLoadData: (params) => {
      dispatch(LoadAction.fetchLoadData(params));
    },
    getLoadData: (params) => {
      dispatch(fetchLoaddata(params));
    },

    fetchTripEvents: (params) => {
      dispatch(fetchTripEvents(params));
    },

    fetchinboxrequest: (params) => {
      dispatch(fetchinboxrequest(params));
    },

    fetchexpense: (params) => {
      dispatch(ExpenseAction.fetchexpense(params));
    },

    fetchmyplans: (params) => {
      dispatch(SubscriptionAction.fetchmyplans(params));
    },
    fetchTripPlanByIdAction: (data) => {
      dispatch(fetchTripPlanByIdAction.fetchTripPlanByIdAction(data));
    },
  };
}

function mapStateToProps(state) {
  console.log(
    "=======state.tripDesignReducer.tabKey======",
    state.tripDesignReducer.tabKey
  );
  return {
    unreadnotificationcount: state.notificationReducer.unreadnotificationCount,
    tripplantab: state.tripDesignReducer.tabKey,
    plannedList: state.TripDesignCrudReducer.plannedList,
  };
}

export default connect(mapStateToProps, bindAction)(DefaultLayout);
